import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/operations/order-cutoffs')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/operations/order-cutoffs']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
